import { Dropdown, GetProps } from 'antd';
type DropdownButtonProps = GetProps<typeof Dropdown.Button>;

const BCDropButton = (props: DropdownButtonProps) => <Dropdown.Button {...props} />;
export { BCDropButton };
